export default __webpack_public_path__ + "static/media/logo-hub-min.67ef2b49.svg";